<template>
  <v-menu
    v-model="isMenuOpen"
    offset-y
    content-class="mt-2"
    :nudge-left="175"
    :close-on-content-click="false"
  >
    <template #activator="{on, attrs}">
      <z-chip
        class="mr-1"
        x-small
        :close="value != null"
        :selected="value != null"
        :text="text"
        :icon="icon"
        :color="color"
        :icon-color="iconColor"
        :disabled="disabled"
        v-bind="attrs"
        v-on="on"
        @click:close="$emit('input', {id: id, value: null})"
      />
    </template>

    <z-card width="350">
      <template #content>
        <div class="content-container">
          <div class="slider-title">
            {{ configuration.title }}
          </div>

          <z-slider
            class="mt-4"
            color="white"
            track-color="#c4c4c4"
            fill-color="#c4c4c4"
            :value="value"
            :min="configuration.min"
            :max="configuration.max"
            @change="onChangeSlider"
          >
            <template #prepend>
              <div class="slider-content body3">
                <span>{{ configuration.min }}</span>
                <span>{{ configuration.unit }}</span>
              </div>
            </template>

            <template #append>
              <div class="slider-content body3">
                <span>{{ configuration.max }}</span>
                <span>{{ configuration.unit }}</span>
              </div>
            </template>

            <template #thumb-label>
              <z-card width="auto" shadow>
                <template #content>
                  {{ sliderValue }}
                </template>
              </z-card>
            </template>
          </z-slider>

          <v-divider></v-divider>

          <div class="d-flex justify-end">
            <z-btn
              rounded
              small
              class="mr-1"
              :text="$t('cancel')"
              :color="color"
              @click="isMenuOpen = false"
            ></z-btn>

            <z-btn
              rounded
              small
              primary
              dark
              :text="$t('add')"
              :color="color"
              @click="onConfirm"
            ></z-btn>
          </div>
        </div>
      </template>
    </z-card>
  </v-menu>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: '',
    },

    text: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },

    value: {
      type: [Number, String],
      default: null,
    },

    color: {
      type: String,
      default: 'var(--primary)',
    },

    configuration: {
      type: Object,
      default: () => ({
        min: 0,
        max: 100,
        unit: '',
        title: '',
      }),
    },
    iconColor: {
      type: String,
      default: '',
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isMenuOpen: false,
    sliderValue: 0,
  }),

  watch: {
    value: {
      immediate: true,
      handler(value) {
        this.sliderValue = value
      },
    },
  },

  methods: {
    onConfirm() {
      this.isMenuOpen = false
      this.$emit('input', {id: this.id, value: this.sliderValue})
    },

    onChangeSlider(value) {
      this.sliderValue = value
    },
  },

  i18n: {
    messages: {
      en: {
        add: 'Add',
        cancel: 'Cancel',
      },
      pt: {
        add: 'Adicionar',
        cancel: 'Cancelar',
      },
      es: {
        add: 'Agregar',
        cancel: 'Cancelar',
      },
    },
  },
}
</script>

<style scoped lang="scss">
:deep(.v-chip__close) {
  font-size: 12px !important;
}
.content-container {
  display: grid;
  gap: 15px;
}
.slider-title {
  color: var(--black);
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 18px */
  text-transform: capitalize;
}

.slider-content {
  display: flex;
}
</style>
